import React, { useState, useEffect } from "react"

import { Form, Constant } from "../../constants"
import SummaryReportCard from "../SummaryReportCard";
import './style.css';
import { useTranslation } from 'react-i18next';

const SummaryReport = (props) => {
    const { t: translate } = useTranslation();
    const {
        data,
        error,
        onClose
    } = props

    const search = {
        "materiel-immat": true,
        "materiel-numserie": true,
        "materiel-numchassis": true,
        "materiel-numparc": true
    }
    const characteristic = {
        "materiel-marque": true,
        "materiel-type": true,
        "materiel-categorie": true,
        "materiel-capacite": true,
        "materiel-mise_en_circulation": true,
        "materiel-annee_fabrication": true
    }
    const operation = {
        "exploitant-raisonsociale": true,
        "exploitant-adresse1": true,
        "exploitant-adresse2": true,
        "exploitant-codepostal": true,
        "exploitant-ville": true,
        "exploitant-mail": true,
        "exploitant-identifiant_client": true
    }
    const enregistrement = {
        "date-controle": true
    }
    const ignoreObject = {
        "_parametres_": true,
        "Matériel": true,
        "Exploitant": true,
        "options de relance": true,
        "copies et enregistrement": true
    }

    const dataEntry = [
        {
            step: 1,
            flowName: "Matériel",
            title: translate('equipmentIdentification'),
            components: search
        },
        {
            step: 1,
            flowName: "Matériel",
            title: translate('materialFeatures'),
            components: characteristic
        },
        {
            step: 2,
            flowName: "Exploitant",
            title: translate('equipmentOperator'),
            components: operation
        },
        {
            flowName: "",
            components: "form-group"
        },
        {
            step: 5,
            flowName: "copies et enregistrement",
            title: "Enregistrement",
            components: enregistrement
        },
    ]

    const [summaryCards, setSummaryCards] = useState([])
    const [firstError, setFirstError] = useState("")
    const [toGoStep, setToGoStep] = useState("")

    const seperateForm = () => {
        const formConstant = Form.getForm();
        const formData = formConstant[localStorage.getItem(Constant.localStorageKey.formId)]

        let errorInput = {}
        if (error.length > 0) {
            setFirstError(error[0])
        }
        error.forEach(e => {
            errorInput = { ...errorInput, [e]: true }
        })

        const lastEle = dataEntry[dataEntry.length - 1]
        const temp = []
        dataEntry.forEach(entry => {
            if (entry.flowName === "") {
                for (let key of Object.keys(formData)) {
                    if (key === "Conclusion du contrôle") {
                        temp.push({
                            step: 4,
                            flowName: key,
                            title: key,
                            components: "form-group"
                        })
                    }
                    else if(!ignoreObject[key]){
                        temp.push({
                            step: 3,
                            flowName: key,
                            title: key,
                            components: "form-group"
                        })
                    }
                }
            }
        })
        let dataToRendered = dataEntry.filter(e => e.flowName != "" && e.flowName != "copies et enregistrement")
        dataToRendered = [...dataToRendered, ...temp]
        dataToRendered.push(lastEle)


        const summaryCardsTemp = [];
        dataToRendered.forEach(entry => {
            const renderedInput = []
            const schema = formData[entry.flowName]
            for (let [key, value] of Object.entries(schema)) {
                if (entry.components === "form-group") {
                    renderedInput.push(value)
                    continue
                }

                if (entry.components[key]) {
                    renderedInput.push(value)
                }
            }

            if (error.length > 0) {
                renderedInput.forEach(input => {
                    if (input.name === error[0]){
                        setToGoStep(entry.step)
                    }
                })
            }

            summaryCardsTemp.push(<SummaryReportCard key={entry.title} title={entry.title} schema={renderedInput} data={data} error={errorInput} formStep={entry.step} />)
        })

        setSummaryCards(summaryCardsTemp);
    }

    const onReturn = () => {
        if(firstError.length > 0){
            window.dispatchEvent(new Event(Constant.event.closeSummary))
            window.dispatchEvent(new CustomEvent(Constant.event.goToSpecificStep, { detail: { step: toGoStep, inputName: firstError } }))
        }
        else {
            window.dispatchEvent(new Event(Constant.event.closeSummary))
            window.dispatchEvent(new CustomEvent(Constant.event.goToSpecificStep, { detail: { step: 1, inputName: "" } }))
        }
    }

    useEffect(() => {
        seperateForm()
    }, [])

    return <div className="report">
        <button className="form-group" onClick={onReturn}>{translate('backToEntry')}</button>
        {summaryCards}
        <button className="form-group" onClick={onReturn}>{translate('backToEntry')}</button>
        {error.length === 0 ? <button className="form-group mt-5" onClick={onClose}>{translate('confirmInformation')}</button> : null}
    </div>
}

export default SummaryReport;